import { updateUserInfo } from "screens/Root/features/slices/rootSlice";
import { useDispatch } from "react-redux";
export const useUser = () => {
    const dispatch = useDispatch();
    // updates the user info object with new values
    const updateUser = (user) => dispatch(updateUserInfo(user));
    return { updateUserInfo: updateUser };
};
